export default "__VITE_ASSET__DtgCxlEB__"